import { useEffect, useState } from "react";

export type TurboProduct = {
	start_date?: string;
	end_date?: string;
	duration?: number;
	start_hour?: string;
};

// El turbo termina en end_date a la hora start_hour (así lo indexa el publisher:
// TIMESTAMP(end_date, start_hour)), en hora de Colombia (UTC-5, sin DST).
const COLOMBIA_UTC_OFFSET = "-05:00";

export const getTurboEndTime = (turbo?: TurboProduct): number | null => {
	if (!turbo || !turbo.end_date) return null;

	const datePart = String(turbo.end_date).slice(0, 10);
	const hourPart = turbo.start_hour || "00:00:00";
	const end = Date.parse(`${datePart}T${hourPart}${COLOMBIA_UTC_OFFSET}`);

	return isNaN(end) ? null : end;
};

export const formatRemaining = (ms: number): string => {
	const totalSeconds = Math.max(0, Math.floor(ms / 1000));
	const hours = Math.floor(totalSeconds / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;
	const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

	return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

// Gate para ListingCard: ¿hay un Asciende activo? Client-only (durante el SSR devuelve
// false, así el server y el primer render del cliente coinciden → sin desajuste de
// hidratación). Re-renderiza la card SOLO al montar y una vez al expirar (un setTimeout
// al fin exacto), nunca por segundo — el tick corre aislado dentro del AsciendeChip.
export const useTurboActive = (turbo?: TurboProduct): boolean => {
	const [active, setActive] = useState(false);

	useEffect(() => {
		const end = getTurboEndTime(turbo);
		if (!end || end <= Date.now()) {
			setActive(false);
			return;
		}
		setActive(true);
		// setTimeout admite hasta ~24.8 días; un turbo más largo caería antes → el tier
		// reaparece recién en el próximo render natural (aceptable, caso extremo).
		const ms = Math.min(end - Date.now(), 2 ** 31 - 1);
		const timeoutId = setTimeout(() => setActive(false), ms);
		return () => clearTimeout(timeoutId);
	}, [turbo && turbo.end_date, turbo && turbo.start_hour]);

	return active;
};
